<template>
	<div class="home">
		<app-main></app-main>
	</div>
</template>

<script>
	import AppMain from '../components/layout/app-main'
	export default {
		name: 'home',
		components: {
			AppMain
		}
	}
</script>

<style lang="scss">
	@import '~@/assets/scss/main.scss';

	.home {
		height: 100%;
		width: 100%;
		// background-color: #121C2B !important;

	}

	.el-picker-panel {
		.el-button--default {
			background-color: #0D283F !important;
			border: 1px solid #007297 !important;
			color: white !important;
		}
	}
</style>
